<template>
  <tr>
    <td style="width:35%;"><span v-if="showCategoryName">{{ category.name }}</span></td>
    <td>
      <b-icon
        variant="primary"
        :icon="collapsed ? 'dash-square' : 'plus-square'"
        style="cursor: pointer;"
        @click="$emit('mealToggle')"
        v-if="showCollapse" />
    </td>
    <td>
      {{ meal.label }}
    </td>
    <td class="full-price">
    <span class="pointer"
      :style="'text-decoration:' + (meal.discount ? 'line-through' : '')"
      @click="$emit('priceDetails')"
    >
    <!-- {{ meal.price + meal.tax + meal.discount | currency('&euro;')}}</span> -->
    {{ getFullPrice({ meal, starRating, fees }) }} {{ currency }}</span>
    </td>
    <td :class="meal.discount ? 'sale-price':'info-price'  ">
    <span class="pointer"
      @click="$emit('priceDetails')"
      v-if="meal.discount"
    >
      <!-- {{ meal.price + meal.tax | currency('&euro;')}}</span> -->
      {{ getPrice({ meal, starRating, fees }) }} {{ currency }}</span>
    </td>
    <td class="text-center">
      <span v-if="category.isSpecial" class="SPO" v-b-tooltip.hover :title="$gettext('Special Offer')">
        SPO
      </span>
      <span v-if="category.isEarlyBooking" class="BD" v-b-tooltip.hover :title="$gettext('Early Booking')">
        EBD
      </span>
      <span v-if="category.isFreePax" class="FC" v-b-tooltip.hover :title="$gettext('Free Child')">
        FC
      </span>
      <span v-if="status=='avl'" class="FCAVL" v-b-tooltip.hover :title="$gettext('Available')">AVL</span>
      <span v-if="status=='req'" class="RQNA" v-b-tooltip.hover :title="$gettext('On Request')">
        RQ
      </span>
      <span v-if="status=='n/a'" class="RQNA" v-b-tooltip.hover :title="$gettext('Stop sale')">
        N/A
      </span>
    </td>
    <td class="text-right" v-if="canBook">
      <b-btn
        v-if="canBook"
        size="sm"
        variant="warning"
        type="button"
        @click="$emit('book')"
      >{{ (status == 'req') ? $gettext('Request') : $gettext('Book') }}</b-btn>
    </td>
  </tr>
</template>

<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'

export default {
  props: {
    meal: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    flight: {
      type: Object,
      required: false
    },
    currency: {
      type: String,
      required: true
    },
    starRating: {
      type: Number,
      default: 0
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: true
    },
    showCollapse: {
      type: Boolean,
      required: false,
      default: true
    },
    showCategoryName: {
      type: Boolean,
      required: false,
      default: true
    },
    showBook: {
      type: Boolean,
      required: false,
      default: true
    },
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  computed: {
    canBook () {
      return this.category.isBookable && (this.flight?.isBookable ?? true)
    },
    flightIsOnRequest () {
      return this.flight?.isOnRequest ?? false
    },
    status () {
      if (this.category.hotelIsBlackedOut) return 'n/a'
      if (this.category.hotelIsAvailable) return this.flightIsOnRequest ? 'req' : 'avl'
      return 'req'
    }
  },
  methods: {
    getPrice, getFullPrice
  }
}
</script>

<style lang="css">
  .pointer {
    cursor:pointer;
  }
</style>
